import mixpanel from 'mixpanel-browser'

let mixpanelObj = {
  track: (eventName: string, recordObj?: Object) => {
    console.log(eventName, recordObj || '')
  }
}

if (
  process.env.NODE_ENV === 'production' &&
  process.env.REACT_APP_MIXPANEL_TOKEN
) {
  mixpanelObj = mixpanel
  mixpanelObj.init(process.env.REACT_APP_MIXPANEL_TOKEN)
}

export default mixpanelObj



// WEBPACK FOOTER //
// ./src/utils/analytics.js